import React, { useEffect, useMemo, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import FilterSVG from 'component/svgComponents/filter'
import Col from 'component/utils/Col'
import ContentHeader from 'component/utils/ContentHeader'
import SideFilterList from 'component/priceBanner/priceBannerList/SideFilterList'
import TableList from 'component/priceBanner/priceBannerList/TableList'
import Row from 'component/utils/Row'
import NewPagination from 'component/pagination/newPagination'
import SizeSelect, { components } from 'react-select'
import DropdownArrow from 'component/svgComponents/dropdownArrow'
import { colourStyles } from 'utils/selectStyle'
import { ListImportModal } from 'component/priceBanner/priceBannerList/ListImport'
import ListEditModal from 'component/priceBanner/priceBannerList/EditListModal'
import SuccessModal from 'component/Modal/SuccessModal'
import PricebannerErrorModal from 'component/priceBanner/general/PricebannerErrorModal'
import DynamicsSelector from 'component/priceBanner/general/DynamicsSelector'
import PricebannerWarningModal from 'component/priceBanner/general/PricebannerWarningModal'
import DetailedWarningModal from 'component/Modal/DetailedWarningModal'
import SearchForm from 'component/priceBanner/priceBannerList/PricebannerSearchForm'
import moment from 'moment'
import * as pricebannerListActions from 'action/pricebannerList'
import { normalizeConflictProductError } from 'action/pricebannerList'
import { showSpinner, hideSpinner } from 'action/spinner'
import '../pictograms/pictograms.css'
import './styles.css'
import PricebannerConfirmExitModal from 'component/priceBanner/general/PricebannerConfirmExitModal'
import ViewModal from 'component/priceBanner/priceBannerList/ViewModalList'
import ExclusionModalPriceBanner from 'component/priceBanner/general/ExclusionModalPriceBanner'
import { STATUS_TYPE } from 'constants/config'
import { browserHistory } from 'react-router'

const DEFAULT_PAGINATION = {
  hasPagination: true,
  page: 1,
  size: 10,
}

const DEFAULT_INITIAL_VALUES = {
  order: 'status',
  orderDirection: "ASC",
  name: 'Todos',
  idBranches: [],
  idBranchesCodes: [],
}

const EXTRA_SMALL_SCREEN = 768

const PriceBannerListContainer = ({
  auth: {
    user: { dsToken },
  },
  translate,
  fetchAll,
  update,
  deleteList,
  uploadList,
  validateProducts,
  validateBranches,
  cancelValidation,
  clearPriceBannerList,
  deleteProductFromList,
  dispatch,
  list,
  metadata,
  dataValidation,
  errorValidation,
  auth,
}) => {
  const displayList = (list || []).map(item => {
    const uniqueBranches = (item.branches || []).filter((branch, index, self) =>
      self.findIndex(b => b.idBranch === branch.idBranch) === index
    );
    const uniqueBranchNamesGrouped = (item.branchNamesGrouped || []).filter((name, index, self) =>
      self.indexOf(name) === index
    );
    let statusConverted = '-';

    if (item.statusDescription) {
      statusConverted = item.statusDescription;
    } else if (item.status !== undefined && item.status !== null) {
      statusConverted = STATUS_TYPE[item.status] || '-';
    }

    const mappedItem = {
      cdPricebannerThemesList: item.idPriceBannerList,
      nameList: item.name,
      themeName: item.themeName,
      themeCode: item.themeCode,
      dtStart: item.dtStart,
      dtEnd: item.dtEnd,
      statusList: statusConverted,
      branches: uniqueBranches,
      branchNamesGrouped: uniqueBranchNamesGrouped,
      productLms: item.productLms || [],
      productCount: item.productCount || 0
    };
    return mappedItem;
  });

  const [openAddModal, setOpenAddModal] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [actionMode, setActionMode] = useState(false)
  const [order, setOrder] = useState({ order: 'status', orderDirection: 'ASC' })
  const [lastTriedPayload, setLastTriedPayload] = useState(null)
  const [openWarningModal, setOpenWarningModal] = useState(false)
  const [showConfirmExitModal, setShowConfirmExitModal] = useState(false)
  const [emptyFilter, setEmptyFilter] = useState(true)
  const [openViewModel, setOpenViewModel] = useState({ show: false, selected: null })
  const [openEditModal, setOpenEditModal] = useState({ show: false, selected: null })
  const [openDeleteModal, setOpenDeleteModal] = useState({ show: false, selected: null })
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [optionSize, setOptionSize] = useState(10)
  const [cdDynamicList, setCdDynamicList] = useState([])
  const [selectedItemsData, setSelectedItemsData] = useState([])
  const [filters, setFilters] = useState()
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION)
  const [sideFilterElement, setSideFilterElement] = useState(null)
  const [sideFilterVisible, setSideFilterVisible] = useState(false)
  const [sideFilterWidth, setSideFilterWidth] = useState(0)
  const [errorDetails, setErrorDetails] = useState("Tempo Expirado")
  const [errorDetailsAsHtml, setErrorDetailsAsHtml] = useState("")
  const [successMessage, setSuccessMessage] = useState('')
  const [failedOperation, setFailedOperation] = useState(null)
  const [failedDeleteData, setFailedDeleteData] = useState(null)
  const [showThemeWarningModal, setShowThemeWarningModal] = useState(false)
  const [themeWarningMessage, setThemeWarningMessage] = useState('')
  const [themeWarningType, setThemeWarningType] = useState('warning')
  const [themeWarningScrollableList, setThemeWarningScrollableList] = useState(null)
  const [showProductsWarningModal, setShowProductsWarningModal] = useState(false)
  const [invalidProducts, setInvalidProducts] = useState([])

  const headerRef = useRef(null)
  const filterRef = useRef(null)
  const tableRef = useRef(null)
  const forceCloseRef = useRef(false)
  const searchFormRef = useRef(null)

  useEffect(() => {
    clearPriceBannerList();

    const savedFilters = sessionStorage.getItem('priceBannerListFilters')
    let initialFilters = DEFAULT_INITIAL_VALUES

    if (savedFilters) {
      try {
        const parsedFilters = JSON.parse(savedFilters)
        initialFilters = { ...DEFAULT_INITIAL_VALUES, ...parsedFilters }
        sessionStorage.removeItem('priceBannerListFilters')
        // eslint-disable-next-line no-empty
      } catch (error) {
      }
    }

    const param = {
      ...initialFilters,
      ...DEFAULT_PAGINATION
    }

    setFilters(initialFilters)
    fetchAll(dsToken, param)
  }, [])

  useEffect(() => {
    if (!filters) return
    const param = {
      ...DEFAULT_PAGINATION,
      ...filters,
      ...order,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    }

    delete param.idBranchesCodes;
    fetchAll(dsToken, param)
  }, [filters])

  useEffect(() => {
    if (!filters) return
    const param = {
      ...filters,
      ...pagination,
      ...order,
      page: pagination.page,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    };
    fetchAll(dsToken, param)
  }, [pagination])

  useEffect(() => () => window.removeEventListener('resize', handleResize))

  const handleResize = () => {
    const header = headerRef.current
    const filter = filterRef.current

    if (header && filter && window.innerWidth > EXTRA_SMALL_SCREEN) {
      const headerClientHeight = header.clientHeight
      filter.style.top = `${headerClientHeight}px`
      if (sideFilterVisible && sideFilterElement) {
        const newSideFilterWidth = sideFilterElement.clientWidth
        if (sideFilterWidth !== newSideFilterWidth) {
          setSideFilterWidth(newSideFilterWidth)
        }
      }
    }
  }

  const closeFilter = () => setSideFilterVisible(false)

  const resetFilters = () => setValues(DEFAULT_INITIAL_VALUES)

  const setValues = (values, isSearch = false) => {
    if (isSearch && values) {
      setEmptyFilter(false)
      setFilters({ ...filters, name: values, page: 1, o: Math.random() })
      return
    }
    if (isSearch && !values) {
      delete filters.name
      setFilters({ ...filters, page: 1, o: Math.random() })
      setEmptyFilter(true)
      return
    }

    const newFilters = { ...filters, ...values, page: 1, o: Math.random() }

    if ('idBranches' in values) {
      delete newFilters.idBranchesCodes
    }
    if ('idBranchesCodes' in values) {
      delete newFilters.idBranches
    }

    delete newFilters.name
    setEmptyFilter(true)

    if (searchFormRef.current && searchFormRef.current.clear) {
      searchFormRef.current.clear()
    }

    if (!('status' in values)) {
      delete newFilters.status
    }

    if (!('themeCode' in values)) {
      delete newFilters.themeCode
    }

    if (newFilters.dtStart === null || newFilters.dtStart === undefined) {
      delete newFilters.dtStart
    }
    if (newFilters.dtEnd === null || newFilters.dtEnd === undefined) {
      delete newFilters.dtEnd
    }

    setFilters(newFilters)
  }

  const removeSelected = (cdParam) => {
    const hasSelected = cdDynamicList.includes(cdParam);
    if (hasSelected) {
      const newSelecteds = cdDynamicList.filter(param => param !== cdParam);
      const newSelectedData = selectedItemsData.filter(item => item.cdPricebannerThemesList !== cdParam);
      setCdDynamicList(newSelecteds);
      setSelectedItemsData(newSelectedData);
    }
  }

  const addSelectedItem = (itemData) => {
    const isAlreadySelected = cdDynamicList.includes(itemData.cdPricebannerThemesList);
    if (!isAlreadySelected) {
      setCdDynamicList([...cdDynamicList, itemData.cdPricebannerThemesList]);
      setSelectedItemsData([...selectedItemsData, itemData]);
    }
  }

  const processValidationResult = (result, selectedBranches) => {
    const invalidStores = result?.invalidStores || result?.data || [];

    if (!Array.isArray(invalidStores) || invalidStores.length === 0) {
      return false;
    }

    const buildWarningMessage = (validCount, invalidCount) => {
      const successKey = 'price.banner.theme.success';
      const integrationKey = validCount === 1 ? 'price.banner.theme.warning.integration.singular' : 'price.banner.theme.warning.integration.plural';
      const detailsKey = invalidCount === 1 ? 'price.banner.theme.warning.details.singular' : 'price.banner.theme.warning.details.plural';
      const successMsg = `<div class="price-banner-warning-success-message"><strong class="price-banner-warning-success-title">${translate(successKey)}</strong></div>`;
      const warningMsg = `${successMsg}<div class="price-banner-warning-message">${translate(integrationKey)}</div>`;
      return warningMsg + translate(detailsKey).replace('{details}', '').trim();
    };

    const invalidCount = invalidStores.length;
    const allInvalid = invalidCount === selectedBranches.length;

    if (allInvalid) {
      setThemeWarningMessage(translate(invalidCount === 1 ? 'price.banner.theme.error.total.singular' : 'price.banner.theme.error.total.plural'));
      setThemeWarningType('error');
      setThemeWarningScrollableList([]);
      setShowThemeWarningModal(true);
      return true;
    }

    const validCount = selectedBranches.length - invalidCount;
    setThemeWarningMessage(buildWarningMessage(validCount, invalidCount));
    setThemeWarningType('warning');

    const formattedStores = invalidStores.map(store => {
      const branchId = store.branchId || store.branch_id || '';
      const branchName = store.branchName || store.branch_name || '';
      return `${branchId.padStart(4, '0')} - ${branchName}`;
    });

    setThemeWarningScrollableList(formattedStores);
    setShowThemeWarningModal(true);
    return true;
  };

  const buildLastTriedPayload = (metadata, file) => ({
    metadata,
    file,
    validProducts: metadata.productLms || [],
    extractedProducts: metadata.productLms || [],
    validProductsWithDescriptions: metadata.productDescriptions || {},
    showValidationResults: true,
    validationComplete: true
  });

  const handleCreate = async (metadata, file) => {
    const formattedMetadata = {
      ...metadata,
      dtStart: metadata.dtStart ? moment(metadata.dtStart).format('YYYY-MM-DD') : metadata.dtStart,
      dtEnd: metadata.dtEnd ? moment(metadata.dtEnd).format('YYYY-MM-DD') : metadata.dtEnd
    };

    const payload = buildLastTriedPayload(metadata, file);
    setLastTriedPayload(payload);

    const selectedBranches =
      Array.isArray(metadata.idBranchesFromFile) && metadata.idBranchesFromFile.length > 0
        ? metadata.idBranchesFromFile
        : metadata.idBranches || [];

    try {
      const result = await uploadList(dsToken, formattedMetadata, file);

      forceCloseRef.current = true;
      setOpenAddModal(false);
      setLastTriedPayload(null);

      const processed = processValidationResult(result, selectedBranches);
      if (processed) return;

      setSuccessMessage(translate('price.banner.list.save'));
      setOpenSuccessModal(true);
    } catch (error) {
      const status = error?.cdStatus || error?.status;
      const conflictingLms = error?.conflictingLms || [];

      if (status === 409 && Array.isArray(conflictingLms) && conflictingLms.length > 0) {
        setInvalidProducts(conflictingLms);
        setLastTriedPayload(payload);
        setShowProductsWarningModal(true);
        return;
      }

      if (status === 400 || status === 409) {
        const themeName = metadata.themeName || metadata.themeCode || '---';
        const startDate = metadata.dtStart ? moment(metadata.dtStart).format('DD/MM/YYYY') : '---';
        const endDate = metadata.dtEnd ? moment(metadata.dtEnd).format('DD/MM/YYYY') : '---';
        const conflictMessage = translate('price.banner.error.conflict.theme.period')
          .replace('{themeName}', themeName)
          .replace('{startDate}', startDate)
          .replace('{endDate}', endDate);
        setErrorDetails(conflictMessage);
        setErrorDetailsAsHtml(conflictMessage);
        setLastTriedPayload(payload);
        setOpenWarningModal(true);
        return;
      }

      if (error?.invalidStores || (Array.isArray(error?.data) && error.data.length > 0)) {
        const errorResult = { invalidStores: error.invalidStores || error.data };
        const processed = processValidationResult(errorResult, selectedBranches);
        if (processed) return;
      }

      let errorMessage = error?.dsMessage || error?.message || translate('price.banner.importlist');

      if (typeof errorMessage === 'object') {
        errorMessage = JSON.stringify(errorMessage);
      } else if (typeof errorMessage !== 'string') {
        errorMessage = String(errorMessage);
      }

      if (errorMessage === 'Failed to fetch') {
        errorMessage = translate('price.banner.error.generic');
      }

      setErrorDetails(errorMessage);
      setLastTriedPayload(payload);
      setFailedOperation('CREATE');
      setOpenErrorModal(true);
    }
  };

  const handleModalClose = () => {
    setOpenSuccessModal(false)

    const param = {
      ...DEFAULT_PAGINATION,
      ...filters,
      ...order,
      size: optionSize,
      idBranches: filters.idBranchesCodes ?? filters.idBranches ?? [],
    };

    delete param.idBranchesCodes;
    fetchAll(dsToken, param);
  }

  const handleAddModalOpenChange = (isOpen) => {
    if (isOpen) {
      forceCloseRef.current = false;
      setOpenAddModal(true);
      return;
    }
    if (!forceCloseRef.current) {
      setShowConfirmExitModal(true);
      return;
    }
    setOpenAddModal(false);
    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const listImportInitialData = useMemo(() => {
    if (!lastTriedPayload) return null;
    if (lastTriedPayload.metadata) {
      return {
        ...lastTriedPayload.metadata,
        file: lastTriedPayload.file,
        validProducts: lastTriedPayload.validProducts,
        invalidProducts: lastTriedPayload.invalidProducts,
        extractedProducts: lastTriedPayload.extractedProducts,
        validProductsWithDescriptions: lastTriedPayload.validProductsWithDescriptions,
        showValidationResults: lastTriedPayload.showValidationResults,
        validationComplete: lastTriedPayload.validationComplete
      };
    }
    return lastTriedPayload;
  }, [lastTriedPayload]);

  const renderAddModal = () => {
    if (!openAddModal) return
    const isRetryMode = !!lastTriedPayload;
    return (
      <ListImportModal
        title={translate('price.banner.importlist')}
        open={openAddModal}
        onOpenChange={handleAddModalOpenChange}
        onSave={handleCreate}
        initialData={listImportInitialData}
        translate={translate}
        user={auth.user}
        validateProducts={validateProducts}
        validateBranches={validateBranches}
        cancelValidation={cancelValidation}
        dataValidation={dataValidation}
        errorValidation={errorValidation}
        isRetryMode={isRetryMode}
        storesInCsv
      />
    )
  }

  const renderSuccessModal = () => {
    if (!openSuccessModal) return
    return (
      <SuccessModal
        fillButton
        center
        handleClose={handleModalClose}
        size='lg'
        buttonText={translate('ok_button')}
        msg={successMessage || translate('parameters.success.msg')}
        t={translate}
      />
    )
  }

  const handleRetry = () => {
    setOpenErrorModal(false);

    switch (failedOperation) {
      case 'CREATE':
      case 'UPDATE':
        break;
      case 'DELETE':
        if (failedDeleteData) {
          setOpenDeleteModal({ show: true, selected: failedDeleteData });
        }
        break;
      default:
        break;
    }

    if (failedOperation === 'DELETE') {
      setFailedOperation(null);
      setFailedDeleteData(null);
    } else {
      setFailedOperation(null);
    }
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
    forceCloseRef.current = true;

    switch (failedOperation) {
      case 'CREATE':
        setOpenAddModal(false);
        setLastTriedPayload(null);
        break;
      case 'UPDATE':
        setOpenEditModal({ show: false, selected: null });
        setLastTriedPayload(null);
        break;
      case 'DELETE':
        setFailedDeleteData(null);
        break;
      default:
        break;
    }

    setFailedOperation(null);

    setTimeout(() => {
      forceCloseRef.current = false;
    }, 10);
  };

  const renderErrorModal = () => {
    if (!openErrorModal) return null;
    const errorMessage = translate('price.banner.error.generic');

    return (
      <PricebannerErrorModal
        onConfirm={handleRetry}
        onClose={handleCloseErrorModal}
        text={errorMessage}
        title={translate('price.banner.modal.ops')}
        details={translate('price.banner.error.details')}
        okButton={(translate('newLogin.errorModal.button.label'))}
        translate={translate}
      />
    )
  }

  const handleSeeExisting = () => {
    setOpenWarningModal(false);
    setOpenAddModal(false);
    setOpenEditModal({ show: false, selected: null });
    clearPriceBannerList();
    const payload = lastTriedPayload?.metadata || lastTriedPayload;
    const themeCode = payload.themeCode || '---';
    const dtStart = moment(payload.dtStart, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const dtEnd = moment(payload.dtEnd, 'YYYY-MM-DD').format('YYYY-MM-DD');
    const idBranches = [...new Set(payload.idBranches || [])];

    const filterParams = {
      ...DEFAULT_PAGINATION,
      ...order,
      size: optionSize,
      dtStart,
      dtEnd,
      themeCode,
      idBranches,
    };
    setFilters({
      dtStart,
      dtEnd,
      themeCode: payload.themeCode,
      idBranches,
    });
    fetchAll(dsToken, filterParams);
    setFilters(DEFAULT_INITIAL_VALUES);
    setLastTriedPayload(null);
    forceCloseRef.current = false;
  };

  const handleCloseWarningModal = () => {
    setOpenWarningModal(false);
    setErrorDetailsAsHtml('');
    forceCloseRef.current = false;
  };

  const handleRetryWarning = () => {
    setOpenWarningModal(false);

    const isEditMode = lastTriedPayload?.idPriceBannerList || openEditModal.selected?.cdPricebannerThemesList;

    if (isEditMode) {
      forceCloseRef.current = true;
      setOpenEditModal({ show: true, selected: openEditModal.selected });
    } else {
      forceCloseRef.current = true;
      setOpenAddModal(true);
    }

    forceCloseRef.current = false;
  };

  const renderWarningModal = () => {
    if (!openWarningModal) return null;
    return (
      <PricebannerWarningModal
        onNewRegister={handleRetryWarning}
        onSeeExisting={handleSeeExisting}
        onClose={handleCloseWarningModal}
        details={errorDetails}
        detailsAsHtml={errorDetailsAsHtml}
        isOpen={true}
        translate={translate}
        customTitle={translate('price.banner.save.already.existent.title')}
        customQuestion={translate('price.banner.save.already.existent.new.question')}
      />
    );
  };

  const handleSeeInvalidProducts = () => {
    setShowProductsWarningModal(false);
    setOpenAddModal(false);

    const payload = lastTriedPayload?.metadata || lastTriedPayload;
    const productLms = invalidProducts || [];

    try {
      if (productLms.length > 0) {
        sessionStorage.setItem('priceBannerInvalidProducts', JSON.stringify(productLms));
      }
      // Salvar a URL atual como URL anterior para o botão de voltar
      const currentUrl = window.location.pathname + window.location.search;
      sessionStorage.setItem('priceBannerPreviousUrl', currentUrl);
    } catch (error) {
      // Ignore session storage errors
    }

    const queryParams = new URLSearchParams();
    const addParam = (key, value) => value && queryParams.append(key, value);

    addParam('dtStart', payload.dtStart && moment(payload.dtStart).format('YYYY-MM-DD'));
    addParam('dtEnd', payload.dtEnd && moment(payload.dtEnd).format('YYYY-MM-DD'));
    payload.idBranches?.forEach(branchId => addParam('idBranches', branchId));

    browserHistory.push(`/pricebanner/list-products?${queryParams.toString()}`);

    setInvalidProducts([]);
    setLastTriedPayload(null);
    setFilters(DEFAULT_INITIAL_VALUES);
  };

  const filterOutInvalidProducts = (payload, invalidSet) => {
    const filteredLms = (payload.productLms || []).filter(lm => !invalidSet.has(lm));
    const filteredDescriptions = { ...payload.productDescriptions };

    invalidSet.forEach(lm => delete filteredDescriptions[lm]);

    return {
      ...payload,
      productLms: filteredLms,
      productDescriptions: filteredDescriptions
    };
  };

  const handleContinueWithoutInvalidProducts = async () => {
    setShowProductsWarningModal(false);

    const payload = lastTriedPayload?.metadata;
    if (!payload) {
      dispatch(hideSpinner());
      return;
    }

    const invalidSet = new Set(invalidProducts);
    const updatedMetadata = filterOutInvalidProducts(payload, invalidSet);

    await handleCreate(updatedMetadata, lastTriedPayload?.file);
    setInvalidProducts([]);
  };

  const buildLmToProductIdMap = (products) => {
    const map = {};
    products.forEach(item => {
      item.productLms?.forEach(lm => {
        if (item.productIds?.[lm]) map[lm] = item.productIds[lm];
      });
    });
    return map;
  };

  const handleContinueWithoutInvalidProductsUpdate = async () => {
    setShowProductsWarningModal(false);
    dispatch(showSpinner());

    const listId = lastTriedPayload?.idPriceBannerList || openEditModal.selected?.cdPricebannerThemesList;
    if (!listId) {
      dispatch(hideSpinner());
      return;
    }

    try {
      const invalidSet = new Set(invalidProducts);
      const invalidProductsArray = Array.from(invalidSet);
      
      const queryParams = new URLSearchParams({ 
        listId: String(listId), 
        page: 1, 
        size: invalidProductsArray.length + 100 
      });
      
      const apiInstance = new Api(dsToken, () => { });
      const productResponse = await apiInstance.post(
        `${API_URL.FIND_PRICEBANNER_LIST}?${queryParams.toString()}`,
        invalidProductsArray
      );
      const products = productResponse?.data?.data || productResponse?.data || [];

      const lmToProductIdMap = buildLmToProductIdMap(products);

      const productIdsToDelete = Array.from(invalidSet)
        .filter(lm => lmToProductIdMap[lm])
        .map(lm => lmToProductIdMap[lm]);

      if (productIdsToDelete.length > 0) {
        try {
          await deleteProductFromList(dsToken, listId, productIdsToDelete);
        } catch (deleteError) {
          dispatch(hideSpinner());
          let errorMessage = deleteError?.message || deleteError?.dsMessage || translate('price.banner.error.generic');
          errorMessage = typeof errorMessage === 'object' ? JSON.stringify(errorMessage) : String(errorMessage);
          if (errorMessage === 'Failed to fetch') errorMessage = translate('price.banner.error.details');
          
          setErrorDetails(errorMessage);
          setFailedOperation('UPDATE');
          setOpenErrorModal(true);
          return;
        }
      }

      const formatDate = (date) => date ? moment(date).format('YYYY-MM-DD') : date;
      const payloadWithId = {
        ...lastTriedPayload,
        dtStart: formatDate(lastTriedPayload.dtStart),
        dtEnd: formatDate(lastTriedPayload.dtEnd),
        idPriceBannerList: listId
      };

      const result = await update(dsToken, payloadWithId);
      const processed = processValidationResult(result, payloadWithId.idBranches || []);

      if (!processed) {
        forceCloseRef.current = true;
        setOpenEditModal({ show: false, selected: null });
        setLastTriedPayload(null);
        setInvalidProducts([]);
        setSuccessMessage(translate('price.banner.list.update'));
        setOpenSuccessModal(true);
      }

      dispatch(hideSpinner());
    } catch (error) {
      dispatch(hideSpinner());

      let errorMessage = error?.message || error?.dsMessage || translate('price.banner.error.generic');
      errorMessage = typeof errorMessage === 'object' ? JSON.stringify(errorMessage) : String(errorMessage);
      if (errorMessage === 'Failed to fetch') errorMessage = translate('price.banner.error.details');

      setErrorDetails(errorMessage);
      setFailedOperation('UPDATE');
      setOpenErrorModal(true);
    }
  };

  const renderProductsWarningModal = () => {
    if (!showProductsWarningModal) return null;

    const isUpdateMode = lastTriedPayload?.idPriceBannerList || openEditModal.selected?.cdPricebannerThemesList;

    const totalProducts = isUpdateMode
      ? (lastTriedPayload?.productLms?.length || 0)
      : (lastTriedPayload?.metadata?.productLms?.length || lastTriedPayload?.productLms?.length || 0);
    const allInvalid = totalProducts > 0 && invalidProducts.length === totalProducts;

    const baseProps = {
      translate,
      title: translate('attention'),
      onClose: () => {
        setShowProductsWarningModal(false);
        setInvalidProducts([]);
      }
    };

    if (allInvalid) {
      return (
        <DetailedWarningModal
          {...baseProps}
          message={translate('price.banner.product.error.total')}
          isError={true}
          showButton1={true}
          button1Text={translate('position.register.edit')}
          onButton1Click={() => {
            setShowProductsWarningModal(false);
            setInvalidProducts([]);
          }}
          button2Text={translate('price.banner.product.see.lms')}
          onButton2Click={handleSeeInvalidProducts}
          singleButtonCenter={false}
        />
      );
    }

    const messageKey = invalidProducts.length === 1
      ? 'price.banner.product.warning.singular'
      : 'price.banner.product.warning.plural';

    const modalProps = {
      ...baseProps,
      message: translate(messageKey),
      isError: false,
      showButton1: true,
      button1Text: translate('price.banner.product.see.lms'),
      onButton1Click: handleSeeInvalidProducts,
      button2Text: translate('price.banner.product.continue'),
      onButton2Click: isUpdateMode ? handleContinueWithoutInvalidProductsUpdate : handleContinueWithoutInvalidProducts,
      scrollableList: invalidProducts
    };

    return <DetailedWarningModal {...modalProps} />;
  };

  const renderThemeWarningModal = () => {
    if (!showThemeWarningModal) return null;

    return (
      <DetailedWarningModal
        translate={translate}
        message={themeWarningMessage}
        messageAsHtml={themeWarningMessage}
        onClose={() => {
          setShowThemeWarningModal(false);
          setThemeWarningMessage('');
          setThemeWarningScrollableList(null);
          if (themeWarningType === 'warning') {
            forceCloseRef.current = true;
            setOpenAddModal(false);
            setOpenEditModal({ show: false, selected: null });
            setLastTriedPayload(null);
            const param = {
              ...DEFAULT_PAGINATION,
              ...filters,
              ...order,
              size: optionSize,
            };
            fetchAll(dsToken, param);
          }
        }}
        isError={themeWarningType === 'error'}
        showButton1={false}
        scrollableList={themeWarningScrollableList}
        singleButtonCenter={true}
      />
    );
  };

  const handleConfirmExit = () => {
    setShowConfirmExitModal(false);
    forceCloseRef.current = true;

    if (cancelValidation) {
      cancelValidation();
    }

    if (openAddModal) {
      setOpenAddModal(false);
      setLastTriedPayload(null);
    }
    if (openEditModal.show) {
      setOpenEditModal({ show: false, selected: null });
    }
    setTimeout(() => {
      forceCloseRef.current = false;
    }, 10);
  };

  const renderConfirmExitModal = () => {
    if (
      !showConfirmExitModal ||
      openErrorModal ||
      openWarningModal ||
      openSuccessModal
    ) {
      return null;
    }
    return (
      <PricebannerConfirmExitModal
        isOpen={showConfirmExitModal}
        onClose={() => setShowConfirmExitModal(false)}
        onConfirm={handleConfirmExit}
        translate={translate}
      />
    );
  };

  const handleOpenEditModalFromView = (param) => {
    setOpenViewModel({ show: false, selected: null });
    setOpenEditModal({ show: true, selected: param });
  };

  const renderViewModal = () => {
    if (!openViewModel.show) return null
    return (
      <ViewModal
        param={openViewModel.selected}
        closeModal={() => setOpenViewModel({ show: false, selected: null })}
        translate={translate}
        openEditModal={handleOpenEditModalFromView}
        currentFilters={filters}
      />
    )
  }

  const handleViewModal = (index) => {
    setOpenViewModel({ show: true, selected: index })
  }

  const handleUpdate = async (payload) => {
    const formattedPayload = {
      ...payload,
      dtStart: payload.dtStart ? moment(payload.dtStart).format('YYYY-MM-DD') : payload.dtStart,
      dtEnd: payload.dtEnd ? moment(payload.dtEnd).format('YYYY-MM-DD') : payload.dtEnd
    };

    const payloadWithId = {
      ...formattedPayload,
      idPriceBannerList: openEditModal.selected.cdPricebannerThemesList,
    };

    setLastTriedPayload(payload);
    const selectedBranches = payload.idBranches || [];

    try {
      const result = await update(dsToken, payloadWithId);

      forceCloseRef.current = true;
      setOpenEditModal({ show: false, selected: null });
      setLastTriedPayload(null);

      const processed = processValidationResult(result, selectedBranches);
      if (processed) return;

      setSuccessMessage(translate('price.banner.list.update'));
      setOpenSuccessModal(true);
    } catch (error) {
      const status = error?.cdStatus;
      const normalizedError = status === 409 ? normalizeConflictProductError(error) : error;
      const conflictingLms = normalizedError?.conflictingLms || [];
      const productLms = normalizedError?.productLms || [];

      if (status === 409 && Array.isArray(conflictingLms) && conflictingLms.length > 0) {
        setInvalidProducts(conflictingLms);

        setLastTriedPayload({
          ...payload,
          idPriceBannerList: openEditModal.selected.cdPricebannerThemesList,
          productLms: productLms.length > 0 ? productLms : payload.productLms || []
        });
        setShowProductsWarningModal(true);
        return;
      }

      if (status === 400 || status === 409) {
        const themeName = payload.themeName || payload.themeCode || '---';
        const dtStart = payload.dtStart ? moment(payload.dtStart).format('DD/MM/YYYY') : '---';
        const dtEnd = payload.dtEnd ? moment(payload.dtEnd).format('DD/MM/YYYY') : '---';

        const message = translate('price.banner.error.conflict.theme.period')
          .replace('{themeName}', themeName)
          .replace('{startDate}', dtStart)
          .replace('{endDate}', dtEnd);
        setErrorDetails(message);
        setErrorDetailsAsHtml(message);
        setOpenWarningModal(true);
        return;
      }

      if (error?.invalidStores || (Array.isArray(error?.data) && error.data.length > 0)) {
        const errorResult = { invalidStores: error.invalidStores || error.data };
        const processed = processValidationResult(errorResult, selectedBranches);
        if (processed) return;
      }

      let errorMessage = error?.message || error?.dsMessage || translate('price.banner.error.generic');

      if (typeof errorMessage === 'object') {
        errorMessage = JSON.stringify(errorMessage);
      } else if (typeof errorMessage !== 'string') {
        errorMessage = String(errorMessage);
      }

      if (errorMessage === 'Failed to fetch') {
        errorMessage = translate('price.banner.error.details');
      }

      setErrorDetails(errorMessage);
      setFailedOperation('UPDATE');
      setOpenErrorModal(true);
    }
  };

  const handleEditModalOpenChange = (isOpen) => {
    if (isOpen) {
      forceCloseRef.current = false;
      return;
    }
    if (!isOpen) {
      if (!forceCloseRef.current) {
        setShowConfirmExitModal(true);
        return;
      }
    }
    setOpenEditModal({ show: isOpen, selected: isOpen ? openEditModal.selected : null });
    if (!isOpen) {
      forceCloseRef.current = false;
    }
  };

  const renderEditModal = () => {
    if (!openEditModal.show) return null;
    return (
      <ListEditModal
        title={translate('price.banner.themes.list.edit')}
        open={openEditModal.show}
        onOpenChange={handleEditModalOpenChange}
        onSave={handleUpdate}
        initialData={openEditModal.selected}
        translate={translate}
        user={auth.user}
        validateProducts={validateProducts}
        dataValidation={dataValidation}
        errorValidation={errorValidation}
      />
    );
  };

  const handleOpenDeleteModal = (selectedIds) => {
    const selectedObjects = selectedIds
      .map(id => {
        const storedItem = selectedItemsData.find(item => item.cdPricebannerThemesList === id);
        if (storedItem) return storedItem;

        return displayList.find(item => item.cdPricebannerThemesList === id);
      })
      .filter(Boolean);
    setOpenDeleteModal({ show: true, selected: selectedObjects });
  };

  const handleConfirmDelete = async (id) => {
    if (!id) return;

    const success = await deleteList(dsToken, [id]);

    if (success) {
      setSuccessMessage(translate('price.banner.list.delete'));
      setOpenSuccessModal(true);
    } else {
      setErrorDetails(translate('price.banner.list.delete.error'));
      setFailedOperation('DELETE');
      const failedItem = displayList.find(item => item.cdPricebannerThemesList === id);
      setFailedDeleteData(failedItem ? [failedItem] : null);
      setOpenErrorModal(true);
    }
  };

  const renderDeleteModal = () => {
    if (!openDeleteModal.show) return null;
    const selectedItems = openDeleteModal.selected || [];

    const isSingle = selectedItems.length === 1;
    const dynamicName = null;
    const renderDeleteMessage = () => {
      if (isSingle) {
        return (
          <div style={{ textAlign: 'center' }}>
            <p style={{ fontSize: '18px' }}>{translate('price.banner.lists.delete.message.singular')}</p>
            <p style={{ fontSize: '14px' }}>
              <strong>Lista:</strong><br />{selectedItems[0].nameList}
            </p>
          </div>
        );
      }
      return (
        <div className='delete-multi-dynamics'>
          <p style={{ fontSize: '18px' }}>
            Você selecionou {selectedItems.length} {selectedItems.length === 1 ? 'lista' : 'listas'}. <br /> Deseja excluí-{selectedItems.length === 1 ? 'la' : 'las'} definitivamente do sistema?
          </p>
          <p style={{ fontSize: '16px', marginTop: '1rem', fontWeight: 'bold' }}>{selectedItems.length === 1 ? 'Lista:' : 'Listas:'}</p>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {selectedItems.map((item, index) => (
              <li key={index}>{item.nameList}</li>
            ))}
          </ul>
        </div>
      );
    };

    const handleConfirmDeleteMultiple = async (selectedItems) => {
      const ids = selectedItems.map((item) => item.cdPricebannerThemesList);
      setOpenDeleteModal({ show: false, selected: null });
      const success = await deleteList(dsToken, ids);

      if (success) {
        const message =
          ids.length === 1
            ? translate('price.banner.list.delete')
            : translate('price.banner.list.delete.plural');

        setSuccessMessage(message);
        setOpenSuccessModal(true);
      } else {
        setErrorDetails(translate('price.banner.list.delete.error'));
        setFailedOperation('DELETE');
        setFailedDeleteData(selectedItems);
        setOpenErrorModal(true);
      }
      setCdDynamicList([]);
    };

    return (
      <ExclusionModalPriceBanner
        isOpen={true}
        useControlledState={true}
        onClose={() => setOpenDeleteModal({ show: false, selected: null })}
        t={translate}
        title={selectedItems.length === 1 ? translate("price.banner.lists.delete") : translate("price.banner.lists.delete.plural")}
        message={renderDeleteMessage}
        dynamicName={dynamicName}
        onConfirm={() => handleConfirmDeleteMultiple(selectedItems)}
        confirmButtonMsg={translate('missionMenu.removeModal.ok')}
        cancelButtonMsg={translate('cancel_button')}
        size="sm"
        renderButton={null}
        customDeleteMessageSingular={translate('price.banner.lists.delete')}
        customDeleteMessagePlural={translate('price.banner.lists.delete.message.plural')}
        itemCount={selectedItems.length}
      />
    );
  };

  const handleOrder = (order, orderDirection) => {
    const param = {
      ...filters,
      ...pagination,
      order,
      orderDirection
    }

    setOrder({ order, orderDirection })

    fetchAll(dsToken, param)
  }

  const renderNewPagination = () => {
    const PAGINATION_OPTIONS = [
      { label: '5', value: 5 },
      { label: '10', value: 10 },
      { label: '20', value: 20 },
      { label: '30', value: 30 },
      { label: '40', value: 40 },
    ]

    const countItems = () => {
      if (metadata.page === 1) return 1;
      return ((metadata.page - 1) * metadata.perPage) + 1;
    };
    const DropdownIndicator = props => (
      <components.DropdownIndicator {...props}>
        <DropdownArrow />
      </components.DropdownIndicator>
    )

    if (!(displayList ?? []).length) return null;
    return (
      <Row className="new-relatory-row stock-transfer-pagination">
        <Col className="align-center margin-bottom">
          <NewPagination
            navClass='pagination new-relatory'
            count={metadata.totalCount}
            current={metadata.page}
            getPage={(page) => {
              setPagination({ ...pagination, size: optionSize, page })
            }}
            pages={metadata.pageCount}
          />

          <div className='datasheet-manager-pagination-size-selector show-pages-new-relatory'>
            <Col className="show-per-page-text" xs={7}>{translate('pagination.size.selector')}</Col>
            <Col xs={4}>
              <SizeSelect
                components={{ DropdownIndicator }}
                isSearchable={false}
                styles={colourStyles}
                classNamePrefix='react-select'
                onChange={(option) => {
                  setOptionSize(option.value)
                  setPagination({ ...pagination, page: 1, size: option.value })
                }}
                options={PAGINATION_OPTIONS}
                value={PAGINATION_OPTIONS.find((i) => i.value === optionSize)}
                menuPlacement='top'
              />
            </Col>
          </div>

          <div style={{ float: 'left' }} className='datasheet-manager-pagination-size-selector show-items-new-relatory'>
            <Col>{`
            ${translate('pagination.size.show')}
            ${countItems()} - ${metadata.page * optionSize > metadata.totalCount
                ? metadata.totalCount
                : metadata.page * optionSize}
            ${translate("pagination.size.of")}
            ${metadata.totalCount}
            ${translate("pagination.size.items")}`}
            </Col>
          </div>
        </Col>
      </Row>
    )
  }

  const isDefaultFilter = () => {
    if (!filters) return true;
    return (
      (filters.idBranches?.length ?? 0) === 0 &&
      (filters.status == null || filters.status === '') &&
      (filters.name === "Todos" || !filters.name)
    );
  };

  useEffect(() => {
    if (cdDynamicList.length > 0 && !actionMode) {
      setActionMode(true)
    }
  }, [cdDynamicList])

  const inActionMode = cdDynamicList.length > 0

  const hasData = (displayList ?? []).length > 0;
  const defaultFilter = isDefaultFilter();
  return (
    <div className='stock-adjustment pricebanner-themes.list'>
      <div ref={headerRef} className='stock-adjustment-header'>
        <ContentHeader>{translate('price.banner.themes.list')}</ContentHeader>
      </div>

      <div ref={filterRef}
        className={`padding-bottom header-mission-block ${cdDynamicList.length === 0 ? 'pricebanner-margin-top' : ''}`}
      >
        <DynamicsSelector
          dynamicsSelected={cdDynamicList}
          cdDynamicList={cdDynamicList.length}
          handleSideFilterMenuCollapseChange={setSideFilterVisible}
          setCdDynamicList={setCdDynamicList}
          setRemoveModal={handleOpenDeleteModal}
          sideFilterVisible={sideFilterVisible}
          translate={translate}
          customQuantityPlural={translate('dynamic.selection.quantityPlural.lists')}
          customQuantitySingular={translate('dynamic.selection.quantitySingular.lists')}
          customRemovePlural={translate('dynamic.selection.removePlural.lists')}
          customRemoveSingular={translate('dynamic.selection.removeSingular.lists')}
          customCancelText={translate('dynamic.selection.cancelPlural')}
        />
      </div>

      {!inActionMode && (
        <div ref={filterRef} className='spacing-end'>
          <div style={{ marginRight: 'auto' }}>
            <SearchForm ref={searchFormRef} visible={true} submit={setValues} translate={translate} currentFilters={filters} />
          </div>

          <div>
            <button
              style={{ marginRight: '12px', background: '#41A017', borderRadius: '8px', height: '44px', color: '#fff' }}
              className='btn filter-mission-block' onClick={() => setOpenAddModal(true)}
            >
              {translate('price.banner.importlist')}
            </button>

            <button style={{ marginRight: '27px' }} className='btn filter-mission-block' onClick={() => setSideFilterVisible(true)}>
              <FilterSVG newDesign={false} className="common-download" />
              <span>{translate('commonReport.filters')}</span>
            </button>
          </div>
        </div>
      )}

      <div
        style={{ margin: '0 !important' }}
        ref={tableRef}
        className='stock-adjustment-table new'
      >
        <div style={{ boxShadow: (displayList ?? []).length < 1 && 'none' }} className='outer-table stock-transfer-outer-table'>
          <div className='flex'>
            <SideFilterList
              user={auth.user}
              resetFilters={resetFilters}
              closeFilters={closeFilter}
              handleSideFilterElementChange={setSideFilterElement}
              initialValues={DEFAULT_INITIAL_VALUES}
              sideFilterVisible={sideFilterVisible}
              submit={setValues}
              translate={translate}
              initialFilters={filters}
            />
            {hasData ? (
              <TableList
                emptyFilter={emptyFilter}
                removeSelected={removeSelected}
                addSelectedItem={addSelectedItem}
                cdDynamicList={cdDynamicList}
                handleOrder={handleOrder}
                handleResize={handleResize}
                handleConfirmDelete={handleConfirmDelete}
                openModal={(index) => handleViewModal(index)}
                editModal={(record) => {
                  setOpenEditModal({ show: true, selected: record });
                }}
                records={displayList}
                setCdDynamicList={setCdDynamicList}
                setSelectedItemsData={setSelectedItemsData}
                translate={translate}
              />
            ) : defaultFilter ? (
              <div
                style={{ width: '100%', height: '500px', margin: '0px' }}
                className='relatory-no-data pictogram-empty no-register'
              >
                <p className="no-register-title">{translate('price.banner.no.lists.registered')}</p>
                <p className="no-register-subtitle">{translate('price.banner.start.registration.adding.lists')}</p>
              </div>
            ) : (
              <div
                style={{ width: '100%', height: '500px', margin: '0px' }}
                className='relatory-no-data pictogram-empty'
              >
                <p style={{ fontSize: '24px' }}>{translate('no.results')}</p>
                <p className='no-result-filter'>{translate('no.results.please')}</p>
              </div>
            )}
          </div>
          {renderNewPagination()}
        </div>
      </div>
      {renderAddModal()}
      {renderSuccessModal()}
      {renderErrorModal()}
      {renderWarningModal()}
      {renderThemeWarningModal()}
      {renderProductsWarningModal()}
      {renderConfirmExitModal()}
      {renderViewModal()}
      {renderEditModal()}
      {renderDeleteModal()}
    </div>
  )
}

PriceBannerListContainer.propTypes = {
  auth: PropTypes.object.isRequired,
  count: PropTypes.number,
  current: PropTypes.number,
  pages: PropTypes.number,
  fetchAll: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
  deleteList: PropTypes.func.isRequired,
  uploadList: PropTypes.func.isRequired,
  validateProducts: PropTypes.func.isRequired,
  validateBranches: PropTypes.func.isRequired,
  cancelValidation: PropTypes.func,
  clearPriceBannerList: PropTypes.func.isRequired,
  deleteProductFromList: PropTypes.func.isRequired,
  find: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  list: PropTypes.array,
  metadata: PropTypes.object,
  dataValidation: PropTypes.object,
  errorValidation: PropTypes.object
}

const mapStateToProps = (state) => ({
  list: state.pricebannerListReducer?.list ?? [],
  metadata: state.pricebannerListReducer?.metadata ?? {},
  error: state.pricebannerListReducer?.error ?? null,
  dataValidation: state.pricebannerListReducer?.dataValidation ?? null,
  errorValidation: state.pricebannerListReducer?.errorValidation ?? null,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      fetchAll: pricebannerListActions.fetchAll,
      update: pricebannerListActions.update,
      deleteList: pricebannerListActions.deleteList,
      uploadList: pricebannerListActions.uploadList,
      validateProducts: pricebannerListActions.validateProducts,
      validateBranches: pricebannerListActions.validateBranches,
      cancelValidation: pricebannerListActions.cancelValidation,
      clearPriceBannerList: pricebannerListActions.clearPriceBannerList,
      deleteProductFromList: pricebannerListActions.deleteProductFromList,
      find: pricebannerListActions.find
    },
    dispatch
  ),
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  translate(null, { wait: true, translateFuncName: 'translate' })(
    PriceBannerListContainer
  )
)

export { PriceBannerListContainer }
